import { create } from 'zustand';

/** Whether the narrow-window sidebar sheet is open; the rail and the installed app's title bar both drive it. */
export const useRailSheet = create<{ open: boolean; setOpen: (open: boolean) => void }>()((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
